import {
  productModuleForWorkspaceType,
  type PlatformModuleId,
} from "@playbookai/types";
import { moduleUnavailableMessage } from "@playbookai/api-clients";
import { moduleStatus } from "../modules/availability.js";

/**
 * Player AI's half of the one availability rule (ADR-0100) in the shell.
 *
 * Nothing here decides availability or names a module: the status comes from
 * the shell's one rule (`moduleStatus`) and the sentence from the shared
 * names and wording pair, so Player AI says exactly what every screen says
 * (d7). Player AI's server narrows its own answers.
 */

/** The d7 phrase for a module this workspace cannot use, or `null` when it can. */
export function moduleUnavailableNotice(
  module: PlatformModuleId,
  tenantEnabledModules: readonly string[] | undefined,
): string | null {
  return moduleUnavailableMessage(
    module,
    moduleStatus(module, tenantEnabledModules),
  );
}

/**
 * The same for a Player AI workspace: a Hoshin workshop is Hoshin's. `null`
 * for Home and for any workspace whose module is available.
 */
export function workspaceUnavailableNotice(
  workspaceType: string | null | undefined,
  tenantEnabledModules: readonly string[] | undefined,
): string | null {
  if (!workspaceType) return null;
  const module = productModuleForWorkspaceType(workspaceType);
  return module === null
    ? null
    : moduleUnavailableNotice(module, tenantEnabledModules);
}
